var map = {
	"./es/announcements/list.json": [
		344,
		4
	],
	"./es/common.json": [
		345,
		5
	],
	"./es/petitions.json": [
		346,
		6
	],
	"./es/survey.json": [
		347,
		7
	],
	"./es/terms.json": [
		348,
		8
	],
	"./es/translation.json": [
		349,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 233;
module.exports = webpackAsyncContext;